const questions = [
  {
    id: 1,
    title: 'Do I have to pay for Treasure? Answer: No',
    info:
      'Answer: No, Treasure is completely free of charge. We do not charge any fees or costs to any party involved. Our mission is to provide a user-friendly and cost-effective chit fund software solution to help you manage your chit funds efficiently. You can enjoy all the benefits of Treasure without any financial burden.',
  },
  {
    id: 2,
    title: 'Is My Financial Information Secure?',
    info:
      'Answer: 100% secure absolutely. At Treasure, we take the security and privacy of your financial information seriously. We have robust security measures in place to ensure that your data is safe and confidential. We do not share anybody information with third parties.Your financial details are encrypted and stored securely on our servers.You can trust that your sensitive data is protected when using Treasure.',
  },
  {
    id: 3,
    title: 'How Does the Chit Auction Process Work?',
    info: `
    The chit auction process on Treasure is designed for efficiency and reliability. Here's how it works:

    - Member Participation: Members can participate in the chit auction by placing bids on upcoming chits.
  
    - Bidding System: Our software ensures that bids are placed quickly and efficiently, often in a matter of seconds.
  
    - Transparent and Fair: The auction process is transparent and fair, with all bids considered.
  
    - Winner Determination: The software determines the winning bid based on the set rules, and the winner is announced.
  
    - Prize Distribution: Once the winner is determined, the prize money is distributed promptly.
  
`  },
  {
    id: 4,
    title: 'How to choose the subscribers?',
    info:
      `
    Selecting the right chit fund subscriptions is crucial. We recommend the following approach:
  
    Start Small: Begin with lower-value chit fund subscriptions. This allows you to get acquainted with the process and build trust.
  
    Gradual Involvement: As you gain confidence and credibility within the chit fund group, consider joining subscriptions with higher values. This approach ensures a gradual and secure investment journey.
  
    By carefully choosing your chit fund subscriptions and starting small, you can make informed decisions and enjoy the benefits of chit fund participation with confidence.
  `,
  },
  {
    id: 5,
    title: 'How to choose the chit fund company?',
    info: `
  When selecting a chit fund company, consider the following factors for a well-informed decision:

  1. Business Experience: Examine the number of years the chit fund company has been in operation. A company with a longer track record may offer more stability and reliability.

  2. Success Record: Investigate how many chit fund groups the company has successfully completed. A strong history of completed groups indicates a trustworthy and efficient operation.

  3. Customer Feedback: Look for reviews and testimonials from previous customers. Positive feedback and a satisfied customer base can be indicative of a reputable company.

  4. Transparency: Ensure that the company provides clear and transparent terms and conditions, with no hidden charges or surprises.

  5. Regulatory Compliance: Verify if the company complies with all legal and regulatory requirements in your region.

  By evaluating these factors, you can make an informed choice when selecting a chit fund company, enhancing your investment experience and peace of mind.
`






    ,
  },
]


export default questions
